/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Pick_PropertyInputs */

const cs_social_hub_pick_property = /** @type {(inputs: Social_Hub_Pick_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte nemovitost`)
};

const en_social_hub_pick_property = /** @type {(inputs: Social_Hub_Pick_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a property`)
};

/**
* | output |
* | --- |
* | "Choose a property" |
*
* @param {Social_Hub_Pick_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_pick_property = /** @type {((inputs?: Social_Hub_Pick_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Pick_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_pick_property(inputs)
	return cs_social_hub_pick_property(inputs)
});